import {
  DataGridModule,
  registerSensikaGridModules,
} from '@sensika/ag-grid-kit';
import { AgDateCellRendererComponent } from './components/cell-renderers/ag-date-cell-renderer/ag-date-cell-renderer.component';
import { AgGridModule } from 'ag-grid-angular';
import { AgGridRuleVolumeComponent } from './components/cell-renderers/rule-volume/rule-volume.component';
import { AgGridUserComponent } from './components/cell-renderers/user/user.component';
import { AgOutputFilesCellRendererComponent } from './components/cell-renderers/ag-output-files-cell-renderer/ag-output-files-cell-renderer.component';
import { AgObjectListCellRendererComponent } from './components/cell-renderers/ag-object-list-cell-renderer/ag-object-list-cell-renderer.component';
import { AgUserCellRendererComponent } from './components/cell-renderers/ag-user-cell-renderer/ag-user-cell-renderer.component';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { GridQuickSearchComponent } from './components/data-grid/grid-quick-search.component';
import { GridSelectionComponent } from './components/data-grid/grid-selection.component';
import { NgModule } from '@angular/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { SharedModule } from '../shared/shared.module';
import { AgBooleanCellRendererComponent } from './components/cell-renderers/ag-boolean-cell-renderer/ag-boolean-cell-renderer.component';

import { AgDataObjectCellRendererComponent } from './components/cell-renderers/ag-data-object-cell-renderer/ag-data-object-cell-renderer.component';
import { AgActionsMenuCellRendererComponent } from './components/cell-renderers/ag-actions-menu-cell-renderer/ag-actions-menu-cell-renderer.component';
import { AgTypePillCellRendererComponent } from './components/cell-renderers/ag-type-pill-cell-renderer/ag-type-pill-cell-renderer.component';
import { AgTagsCellRendererComponent } from './components/cell-renderers/ag-tags-cell-renderer/ag-tags-cell-renderer.component';
import { SaveAgGridSettingsDialogComponent } from './components/save-ag-grid-settings-dialog/save-ag-grid-settings-dialog.component';
import {
  SUI_DIALOG_SIMPLE_SLOTS,
  SUI_DIALOG_TABS_SLOTS,
  SuiDialogSimpleComponent,
  SuiDialogTabsComponent,
} from '@sui/dialog';
import { SuiButtonComponent } from '@sui/button';
import { SuiSelectComponent, SuiSelectOptionComponent } from '@sui/select';
import { SuiInputComponent } from '@sui/input';
import { SuiCheckboxComponent } from '@sui/checkbox';
import { SuiFormFieldComponent, SuiLabelDirective } from '@sui/form-field';
import { SuiBadgeComponent } from '@sui/badge';

// The ag-grid feature modules are registered once, by the grid kit (WAP-1714 list).
registerSensikaGridModules();
@NgModule({
  declarations: [
    GridQuickSearchComponent,
    GridSelectionComponent,
    AgGridUserComponent,
    AgGridRuleVolumeComponent,
    AgObjectListCellRendererComponent,
    AgUserCellRendererComponent,
    AgDateCellRendererComponent,
    AgOutputFilesCellRendererComponent,
    AgBooleanCellRendererComponent,
    AgDataObjectCellRendererComponent,
    AgActionsMenuCellRendererComponent,
    AgTypePillCellRendererComponent,
    AgTagsCellRendererComponent,
    SaveAgGridSettingsDialogComponent,
  ],
  imports: [
    CommonModule,
    AgGridModule,
    DataGridModule,
    NgxChartsModule,
    FontAwesomeModule,
    SharedModule,
    FormsModule,

    SuiDialogTabsComponent,
    SuiDialogSimpleComponent,
    ...SUI_DIALOG_TABS_SLOTS,
    ...SUI_DIALOG_SIMPLE_SLOTS,
    SuiButtonComponent,
    SuiBadgeComponent,
    SuiSelectComponent,
    SuiSelectOptionComponent,
    SuiInputComponent,
    SuiCheckboxComponent,
    SuiFormFieldComponent,
    SuiLabelDirective,
  ],

  exports: [DataGridModule, GridQuickSearchComponent, GridSelectionComponent],
})
export class SensikaAgGridModule {}
